import ActionButton from './ActionButton';

const SaveButton = ({ children, disabled, onClick }) => (
  <ActionButton disabled={ disabled } onClick={ onClick }>
    {children}
  </ActionButton>
);

export default SaveButton;
